// useSupportInbox (issue #419) — GET /chats/support.
//
// Admin/coordinator only on the server side. Status filter is optional;
// the inbox view in #4.6 swaps it per tab.

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getSupportInbox, SupportInboxScope } from './api';
import { chatKeys } from './keys';

import type { Chat } from 'src/models/chat';

export function useSupportInbox(
  status?: string,
  options?: UseQueryOptions<Chat[]>,
  scope: SupportInboxScope = 'legacy'
) {
  return useQuery<Chat[]>(
    chatKeys.supportInbox(status, scope),
    async () => {
      const page = await getSupportInbox(status, scope);
      return page.data ?? [];
    },
    options
  );
}
